var render = function render(){var _vm=this,_c=_vm._self._c;return _c('surroundBox',{attrs:{"name":_vm.description,"unit":_vm.unit,"desc":"粪污加工重量"}},[_c('template',{slot:"content"},[_c('div',{staticClass:"waste-process-echart",staticStyle:{"width":"100%","height":"100%"}})])],2)
}
var staticRenderFns = []

export { render, staticRenderFns }